document.addEventListener('click', (event) => {
  const mobileToggle = event.target.closest('[data-cp-mobile-toggle]');
  if (mobileToggle) {
    const root = mobileToggle.closest('.cp-home');
    const links = root && root.querySelector('.cp-nav__links');
    if (!links) return;
    const isOpen = links.classList.toggle('is-open');
    mobileToggle.setAttribute('aria-expanded', String(isOpen));
    mobileToggle.setAttribute('aria-label', isOpen ? 'Close navigation' : 'Open navigation');
    return;
  }

  const tab = event.target.closest('[data-cp-tab]');
  if (!tab) return;
  const root = tab.closest('.cp-home');
  if (!root) return;
  const category = tab.dataset.cpTab;
  root.querySelectorAll('[data-cp-tab]').forEach((item) => {
    item.classList.toggle('is-active', item === tab);
  });
  root.querySelectorAll('[data-cp-category]').forEach((card) => {
    const categories = (card.dataset.cpCategory || '')
  .split('|')
  .map(item => item.trim());

card.hidden = category !== 'all' && !categories.includes(category);
  });
});
